import React, { useState, useEffect } from 'react'
import Sidebar from '../sidebar'
import NavLogo from '../NavLogo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import dayjs from 'dayjs'
import { Col, Row } from 'react-bootstrap'
import { Button, Checkbox, FormControlLabel, TextField } from '@mui/material'
import TextArea from 'antd/es/input/TextArea'
import axios from 'axios'
import { MDBDataTable } from 'mdbreact'
import { AdminToDoAdd, AdminToDoFindAll } from '../../ApiFile'
import { toast } from 'react-toastify'
import MobileNavbarAdmin from './MobileNavbarAdmin'

const ToDoMainAdmin = () => {
  const [date, setDate] = useState(null)
  const [description, setDescription] = useState('')
  const [createdBy, setCreatedBy] = useState('')
  const [checked1, setChecked1] = useState(false)
  const [checked2, setChecked2] = useState(false)
  const [checked3, setChecked3] = useState(false)
  const [todoData, setTodoData] = useState([]) // State to store fetched data

  // Fetch data from the API when the component mounts
  const fetchData = async () => {
    try {
      const response = await axios.get(AdminToDoFindAll)
      setTodoData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleCheckboxChange = (index) => {
    if (index === 1) {
      setChecked1(!checked1)
    } else if (index === 2) {
      setChecked2(!checked2)
    } else if (index === 3) {
      setChecked3(!checked3)
    }
  }

  const handleSend = async () => {
    const sendToArray = []
    if (checked1) sendToArray.push({ sendto: 2 }) // Superintendent
    if (checked2) sendToArray.push({ sendto: 3 }) // Office Attendant
    if (checked3) sendToArray.push({ sendto: 4 }) // Mess Attendant

    const formattedDate = date ? dayjs(date).format('DD/MM/YYYY') : null

      // ✅ Validation check
  if (!description || !formattedDate || !createdBy || sendToArray.length === 0) {
    toast.error('Please fill all required fields and select at least one recipient.');
    return;
  }

    const requestBody = {
      description,
      completed_by_date: formattedDate,
      createdby: createdBy,
      sendto: sendToArray,
    }

    try {
      const response = await axios.post(AdminToDoAdd, requestBody)
      setCreatedBy('')
      setChecked1('')
      setChecked2('')
      setChecked3('')
      setDescription('')
      setDate(null)
      toast.success('Task Sent Successfully')
      fetchData()
    } catch (error) {
      console.error('Error adding task:', error)
    }
  }

  // Define the columns for MDBDataTable
  const columns = [
    { label: 'Sr. No', field: 'sr_no', sort: 'asc' },
    { label: 'Created Date', field: 'createdDate', sort: 'asc' },
    { label: 'Created By', field: 'createdby', sort: 'asc' },
    { label: 'Send To', field: 'sendto', sort: 'asc' },
    { label: 'Description', field: 'description', sort: 'asc' },
    { label: 'Completed By Date', field: 'completed_by_date', sort: 'asc' },
     { label: 'Status', field: 'status', sort: 'asc' },
  ]

  // Prepare data for MDBDataTable
  const data = {
    columns,
    rows: todoData.map((item, index) => ({
      sr_no: index + 1,

      createdDate: item.createdDate,
      createdby: item.createdby,
      sendto: item.sendto,
      description: item.description,
      completed_by_date: item.completed_by_date,
      status: (
      <span className='shadow'
        style={{
          backgroundColor: item.status === 0 ? 'red' : item.status === 1 ? 'skyblue' : item.status === 2 ? '#ffa500' : item.status === 3 ? 'green' : 'white',
          color:  item.status === 0 ? 'white' : item.status === 1 ? 'black' : item.status === 2 ? 'black' : item.status === 3 ? 'white' : 'black',
          padding: '6px 10px',
          borderRadius: '5px',
          display: 'inline-block',
          minWidth: '100px',
          textAlign: 'center',
        }}
      >
        {item.status === 0 ? 'Pending' : item.status === 1 ? 'Read' : item.status === 2 ? 'In Process' : item.status === 3 ? 'Completed' : '-'}
      </span>
    ),
    })),
  }

  return (
    <>
          <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
            {/* Sidebar on the left for desktop */}
            <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
              <Sidebar />
            </div>
      
            {/* Main content on the right */}
            <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
              <NavLogo />
             
                   <div className="d-block d-md-none">
                     <MobileNavbarAdmin />
                   </div>

<div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
        <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
           To Do
            </h5>
          </div>

        <Row
          className="m-0 p-0 py-1 px-md-5 px-2 w-100"
          style={{ display: 'flex' }}
        >
          <Col
            className="m-0 p-0 px-2 px-md-4 py-3 rounded shadow"
            style={{ background: 'white' }}
          >
            <Row>
              <Col sm={12} md={12} className="mt-3 mt-md-0 pt-md-0 px-md-3">
                <label>Description</label>
                <TextArea
                  label="Text Here"
                  variant="outlined"
                  rows={3}
                  fullWidth
                  size="small"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Col>

              <Col sm={12} md={6} className="mt-3 mt-md-2 pt-md-0">
                <label>Completed By</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker
                      format="DD-MM-YYYY"
                      label="Select Date"
                      className="w-100"
                      value={date}
                      style={{ width: '100%' }}
                      onChange={(newDate) => setDate(newDate)}
                      slotProps={{ textField: { size: 'small' } }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Col>

              <Col sm={12} md={6} className="mt-3 mt-md-3 pt-md-0">
                <label>Created By</label>
                <TextField
                  label="Name Surname"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={createdBy}
                  onChange={(e) => setCreatedBy(e.target.value)}
                />
              </Col>

              <Col sm={12} className="mt-3">
                <label>Send To</label>
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked1}
                      onChange={() => handleCheckboxChange(1)}
                    />
                  }
                  label="Superintendent"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked2}
                      onChange={() => handleCheckboxChange(2)}
                    />
                  }
                  label="Office Attendant"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked3}
                      onChange={() => handleCheckboxChange(3)}
                    />
                  }
                  label="Mess Attendant"
                />
              </Col>

              <Col sm={12} md={12} className="mt-2 mt-md-3 pt-md-0">
                <Col
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    style={{
                      backgroundColor: 'rgb(0, 120, 215)',
                      color: 'white',
                    }}
                    onClick={handleSend}
                  >
                    SEND
                  </Button>
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* MDBDataTable to display fetched ToDo data */}
        <Row className="m-0 p-0 py-1 px-md-5 px-2 w-100">
          <Col
            className="m-0 p-0 px-2 px-md-4 py-3 rounded shadow"
            style={{ background: 'white',overflowX: 'auto' }}
          >
            <MDBDataTable
              striped
              bordered
              className="custom-datatable"
              hover
              data={data}
            />
          </Col>
        </Row>
      </div>
      </div>
      </div>
    </>
  )
}

export default ToDoMainAdmin
